<template>
    <div class="onlineCourseAllCont">
        <div v-loading="loading">

            <!-- 网授进度 -->
            <net-class-pross v-show='netClassData.courses' :netClassData='netClassData' :year='year_value'></net-class-pross>

            <!-- 网授课程列表 -->
            <ul class="compulsoryCourseList">
                <li v-for='(item,idx) in netClassData.courses' :key='item.cid'>
                    <div class="compulsoryCourseImg fl">
                        <img :src="item.thumb" />
                    </div>
                    <div class="compulsoryCourseImgInfor  fl">
                        <p class="compulsoryCourseImgTitle textCut">
                            {{item.name}}
                        </p>
                        <p class="compulsoryCourseScore">
                            <span>学时：{{item.class_hour}}</span><span>学习进度：{{item.progress}}%</span><span style="color:#0173FF;">{{item.is_grade==0?'未评价':'已评价'}}</span></p>
                    </div>
                    <div class="studenInterest">
                        <span class="alreadyJoinBtn blueGradient" @click="jumpVideoLearningPage(idx,item.cid,0,item.is_grade)"
                            v-if='item.progress == 0'>开始学习</span>
                        <span class="alreadyJoinBtn blueGradient" @click="jumpVideoLearningPage(idx,item.cid,1,item.is_grade)"
                            v-else-if='item.progress > 0 & item.progress < 100'>继续学习</span>
                        <span class="alreadyJoinBtn blueGradient" @click="jumpVideoLearningPage(idx,item.cid,2,item.is_grade)"
                            v-else>开始复习</span>
                    </div>
                </li>
            </ul>

            <div v-if='!loading && (netClassData.courses && !netClassData.courses.length)' class="emptyPage">
                暂无课程
            </div>

            <div class="continueselectCourseBtn" v-if='netClassData.courses && !netClassData.courses.length' @click="goSignStudy()">
                立即购课
            </div>

            <div v-if='!loading && !year.length' class="emptyPage">
                您还没有选择课程
            </div>

            <el-dialog title='' class="cameraBox" :visible.sync="showFace" :before-close="handleClose">
                <camera :uploadLoading="uploadLoading" @fileUpload="fileUpload" :show='showFace'></camera>
            </el-dialog>

            <el-dialog title='' center class="hideTitle" :visible.sync="showVideoAllOver" width="30%"
                :close-on-click-modal='false' :close-on-press-escape='false' :show-close='false'>
                <div class="pop">
                    <div class="layerCover"></div>
                    <div class="dialogCont">
                        <p class="onlyPopCont">恭喜！您已学完全部课程</p>
                        <div class="confirmPopBtn">
                            <p class="sureBtn" @click="showVideoAllOver = false">确定</p>
                            <p class="simulationExam" @click="goExam">模拟考试</p>
                        </div>
                    </div>
                </div>
            </el-dialog>

        </div>

    </div>
</template>
<script>
import camera from "../faceCollection/Camera.vue"
import netClassPross from "./netClassPross.vue";

export default {
    components: {
        camera,
        netClassPross
    },
    props: {
        netClassData: {
            type: Object
        },
        year_value:{
            type:Number
        },
        year:{
            type:Array
        }
    },
    data () {
        return {
            showFace: false,
            jumpParams: {},
            course_id: '',
            loading: true,
            showVideoAllOver: false,
            uploadLoading:false
        }
    },
    watch: {
        netClassData () {
            this.loading = false;

            if (this.netClassData.totalPro == 100) {
                if( !localStorage.getItem('showVideoAllOver') ){
                    this.showVideoAllOver = true;
                    localStorage.setItem('showVideoAllOver',true);
                }
            }
        },
    },
    mounted () {

    },
    methods: {
        /**
         * 继续选课
         */
        goSignStudy () {
                this.$router.push({
                    name: 'signStudy',
                    query:{
                        year:this.year_value
                    }
                })
        },

        /**
         * 上传人脸关闭
         * handleClose
         */
        handleClose () {
            this.showFace = false;
        },

        /**
         * 跳转视频页面
         */
        jumpVideoLearningPage (idx, cid, classState, is_grade) {
//             this.jumpParams = {
//                 name: 'videoLearning',
//                 query: {
//                     cid: cid,
//                     classState: classState
//                 }
//             }
//                 localStorage.setItem('videoRefresh','false');
//                 this.$router.push(this.jumpParams)
// return false;


            if (this.netClassData.avatar_status != 1) {
                this.$message('头像正在审核中');
                return false;
            }

            //判断前一个课程是否看完，第一个不用判断
            /*
            if (idx != 0) {
                if (this.netClassData.courses[idx - 1].progress != 100) {
                    this.$message('请先完成前一课程的学习');
                    return false;
                }
                // 判断前一个课程是否评价
                if(this.netClassData.courses[idx - 1].progress == 100 && this.netClassData.courses[idx - 1].is_grade == 0) {
                    this.$message('请先完成前一课程的评价');
                    return false;
                }
            }
            */




            this.course_id = cid;
            this.jumpParams = {
                name: 'videoLearning',
                query: {
                    cid: cid,
                    classState: classState,
                    year:this.year_value //传递年份参数
                }
            }


            if (classState == 2) {
                this.$router.push(this.jumpParams)
            } else {
               // this.showFace = true;
               this.$router.push(this.jumpParams)
                localStorage.setItem('videoRefresh','false');
            }
        },

        /**
         * 上传人脸
         */
        fileUpload (result) {
            this.uploadLoading = true;
            this.$store.dispatch('avatar', { avatar: result, course_id: this.course_id }).then((res) => {
                if (res.code == 200) {
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    setTimeout(() => {
                        this.$router.push(this.jumpParams)
                    }, 1000)
                } else {

                }
                this.uploadLoading = false;
            }).catch(()=>{
                this.uploadLoading = false;
            })
        },

        /**
         * goExam
         * 跳转考试
         */
        goExam () {
            this.$router.push('/examList')
        }
    }
}
</script>
<style lang="stylus" scoped>
.onlineCourseAllCont
    min-height 500px
.emptyPage
    text-align center
    margin-top 100px
    color #666
.onlineTeachingContRight
    margin 10px 0
    background #fff
    /* box-shadow:0px 0px 15px 0px rgba(218,218,218,0.5); */
.onlineTeachingCont
    overflow hidden
.onlineTeachingContPadding
    /* padding:0px 50px 50px 50px; */
    background #fff
    border-radius 4px
.classTypesTab, .onlineConfirmSignUpBtns
    overflow hidden
    margin 0 auto
    text-align center
.classTypesTab > p
    display inline-block
    margin 0 35px
    width 110px
    height 38px
    line-height 38px
    text-align center
    color #0173ff
    font-size 16px
    letter-spacing 2px
    border 1px solid #43affc
    border-radius 4px
    cursor pointer
.onlineConfirmSignUpBtns
    margin-top 100px
.onlineConfirmSignUpBtns > p
    display inline-block
    margin 0 35px
    width 140px
    height 40px
    line-height 40px
    text-align center
    font-size 16px
    letter-spacing 2px
    border 1px solid #43affc
    border-radius 4px
    cursor pointer
.classTypesTab > p.active
    background-image -webkit-linear-gradient(left, #4bb7fc, #0173ff)
    background-image -o-linear-gradient(left, #4bb7fc, #0173ff)
    background-image -ms-linear-gradient(left, #4bb7fc, #0173ff)
    background-image linear-gradient(left, #4bb7fc, #0173ff)
    color #fff
    border none
.onlineTeachingContTop
    position relative
.classTypesSelect
    position absolute
    left 0px
    top 0
.selectedCourse, .selectedCourse span
    font-size 18px
    margin-right 30px
.processBarBox
    display inline-block
    position relative
.processBar
    display inline-block
    width 600px
    height 5px
    background #fff
    border-radius 180px
.processBarBox
    position relative
.currentProcessBar
    position absolute
    height 5px
    width 100px
    background-image -webkit-linear-gradient(left, #4bb7fc, #0173ff)
    background-image -o-linear-gradient(left, #4bb7fc, #0173ff)
    background-image -ms-linear-gradient(left, #4bb7fc, #0173ff)
    background-image linear-gradient(left, #4bb7fc, #0173ff)
    border-radius 180px
    top 12px
    left 0
    right 0
.totalProNum
    position absolute
    right -60px
    top 2px
.compulsoryCourseList
    /* margin:0 5px 0 10px; */
    margin-top 30px
.compulsoryCourseList li
    padding 10px
    overflow hidden
    border-radius 8px
    margin-top 20px
    background rgba(255, 255, 255, 1)
    box-shadow 0px 0px 15px 0px rgba(218, 218, 218, 0.5)
    position relative
.compulsoryCourseImg img
    width 105px
    height 80px
    display block
.compulsoryCourseImgInfor
    max-width 55%
    margin-left 15px
.compulsoryCourseImgTitle
    width 100%
    color #333
    font-weight bold
.compulsoryCourseImgTitle, .compulsoryCourseScore
    margin-top 12px
.compulsoryCourseScore, .compulsoryCourseScore span
    color #999
    font-size 14px
    margin-right 30px
.studenInterest
    position absolute
    right 10px
    bottom 20px
    font-size 14px
.studenInterest span
    display inline-block
    width 82px
    height 26px
    line-height 26px
    /* color:#0173FF; */
    text-align center
    border-radius 4px
    cursor pointer
    margin-right 20px
    border-top-left-radius 12px
    border-bottom-right-radius 12px
.continueselectCourseBtn
    width 290px
    height 40px
    line-height 40px
    text-align center
    color #0173ff
    border 1px solid #0173ff
    border-radius 4px
    font-size 16px
    margin 80px auto 0
    cursor pointer
    margin-bottom 50px
.learnTotalProcess
    margin-top 5px
.popTitle
    text-align center
    font-size 16px
    color #333
    letter-spacing 2px
    font-weight bold
    padding 20px 20px 0
.popCont
    font-size 16px
    color #333
    text-align center
    letter-spacing 2px
    padding 15px 0 15px
    border-bottom 1px solid #eee
.confirmPopBtn
    font-size 16px
    color #0173FF
    text-align center
    letter-spacing 2px
    cursor pointer
    height 48px
    text-align center
    line-height 48px
.onlyPopCont
    text-align center
    font-size 16px
    color #333
    letter-spacing 2px
    font-weight bold
    padding 45px 25px 25px
    border-bottom 1px solid #eee
.confirmPopBtn
    height 48px
    line-height 48px
.confirmPopBtn>p
    float left
    width 50%
    text-align center
    box-sizing border-box
.confirmPopBtn>p.sureBtn
    color #333
.confirmPopBtn>p.simulationExam
    color #0173FF
    border-left 1px solid #eee
</style>


<style lang="stylus">
.cameraBox
    .el-dialog
        width 432px!important
.hideTitle
    .el-dialog__header
        display none
    .el-dialog--center
        .el-dialog__body
            padding 0
    .el-dialog
        border-radius 8px
</style>



// WEBPACK FOOTER //
// src/components/my/myCourse/netClass.vue